import { Icon, Input, TextArea } from 'native-base';
import React, { FC } from 'react';
import { ElementBase, IElementBaseProps, initializeElement } from '..';
import { Feather,  } from "@expo/vector-icons";
import { Box, Text, } from "@gluestack-ui/themed"
import { MarkdownText } from '../base/renderMDText';

export const TextElement: FC<IElementBaseProps> = (({ ...props }) => {
    const {
        element,
        payload, checkAndSetPayload, errorList
    } = initializeElement(props);

    const handleChange = (value: string | undefined) => {
        value = value == undefined ? "" : value.toString();
        if (element.templateData.toChangeCase == "upperCase")
            value = value?.toUpperCase();
        if (element.templateData.toChangeCase == "lowerCase")
            value = value?.toLowerCase();        
        checkAndSetPayload(value);
    }
    
    if (element.templateData.valueAsTitle && element.templateData.readOnly ){
        element.name=payload.value;
        return <ElementBase errors={errorList} element={element} forReview={props.forReview} link={payload.url}></ElementBase>
    }
    
    return <ElementBase errors={errorList} element={element} forReview={props.forReview} link={payload.url} changedMe={payload.value}>
        {props.forReview || element.templateData.readOnly ?
            <Text style={{ color: (element.templateData.textColor ? element.templateData.textColor : "#000") }} size='md'>
                <MarkdownText parser={element.templateData.hasMarkDown ?? false}>{(payload.value)}</MarkdownText>
            </Text>
            :
            <Box>
                {(element.templateData.rowSpan == undefined || element.templateData.rowSpan == 1) ?
                    <Box><Input variant="unstyled" size={"md"}
                        InputLeftElement={element.type == "sendemail" ?<Icon as={Feather} mr="3" name="at-sign" size="md" />:<></>}
                        isReadOnly={element.templateData.readOnly ? true : false}
                        keyboardType={element.type == "sendemail" ? "email-address" : "default"}
                        color={element.templateData.textColor || "#000"}
                        fontWeight={element.templateData.hidden_label ? "bold":"normal"}
                        onChangeText={handleChange}
                        placeholder={element.templateData.placeholder || ""}
                        value={payload.value?.toString() || ""}
                        backgroundColor={element.templateData.readOnly ? undefined: "#00000010"}
                        maxLength={element.templateData.maxLength}
                    /></Box>
                    :
                    <Box><TextArea
                        maxLength={element.templateData.maxLength}
                        variant={element.templateData.readOnly ? "unstyled" : "filled"}
                        isReadOnly={element.templateData.readOnly ? true : false}
                        multiline={true} fontSize={"md"}
                        numberOfLines={element.templateData.rowSpan}
                        keyboardType={element.type == "sendemail" ? "email-address" : "default"}
                        color={element.templateData.textColor || "#000"}
                        onChangeText={handleChange}
                        placeholder={element.templateData.placeholder || ""}
                        value={payload.value?.toString() || ""}
                        autoCompleteType="default" backgroundColor={element.templateData.readOnly ? undefined : "#00000010"}/></Box>
                }
            </Box>
        }
    </ElementBase>
});